import useSWR from "swr";
import {Utils} from "../common/utils";
const clientConfigs = Utils.getEAIClientConfigs();


export type DatasourceSettings = {
    account_id: number,
    authorize_url: string,
    client_id: string,
    client_secret: string,
    icon_url: string,
    redirect_uri_legacy: string,
    redirect_uris: string,
    refresh_token: string,
    setup_complete: string,
    subdomain: string,
    ui_locked: string
}

export type Datasource = {
    id: number,
    datasource_name: string,
    settings: DatasourceSettings
}

export type CanvasDatasourceResponse = {
    data: Datasource
    result: {
        totalCount: number
    }
}

export function useCanvasDataSources() {
    const {data, error, mutate} = useSWR<CanvasDatasourceResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/datasources/canvas`);

    return {
        data,
        error,
        mutate
    };
}
